export default {
  "associationProfile": "商协配置",
  "reset": "重置",
  "save": "保存",
  "basicInfo": "基础信息",
  "associationName": "商协名称",
  "enterTheAssociationName": "请输入商协名称",
  "shownWithTheOrganizationLogoAtThe": "显示在小程序首页左上角，与组织 LOGO 一同展示。",
  "phone": "电话",
  "enterAContactNumber": "请输入联系电话",
  "email": "邮箱",
  "enterAnEmailAddress": "请输入邮箱",
  "contact": "联系人",
  "enterAContactName": "请输入联系人",
  "address": "地址",
  "enterAddress": "请输入地址",
  "organizationLogo": "组织 LOGO",
  "uploading": "上传中…",
  "uploadImage": "上传图片",
  "remove": "移除",
  "weChatAccountQRCode": "公众号二维码",
  "qRCodeDestinationURL": "二维码跳转链接",
  "enterTheURLToOpenWhenThe": "输入点击公众号二维码跳转的链接地址，不填写则不跳转",
  "aboutTheAssociation": "商协介绍",
  "enterAnIntroductionToTheAssociation": "请输入商协介绍",
  "charterAndHonors": "商协章程/荣誉",
  "associationCharter": "商协章程",
  "enterTheAssociationCharter": "请输入商协章程",
  "honors": "荣誉",
  "enterHonorsAndAwards": "请输入荣誉内容",
  "membershipGuidelines": "入会须知",
  "enterMembershipGuidelines": "请输入入会须知",
  "memberBenefits": "会员专属权益",
  "enterBenefitsShownOnTheMembershipApplication": "请输入会员专属权益，将展示在已入会用户的「申请入会」页",
  "restoredTheLastSavedContent": "已恢复为上次保存内容",
  "couldNotLoadData": "加载失败",
  "associationProfileSaved": "商协资料已保存",
  "couldNotSaveChanges": "保存失败",
  "uploadFailed": "上传失败",
  "imageUploaded": "图片已上传",
  "miniProgramSettings": "小程序配置",
  "saveSettings": "保存配置",
  "systemSettings": "系统设置",
  "organizationType": "适用组织",
  "eGChamberOfCommerceAssociationSociety": "如：商会、协会、学会",
  "theMiniProgramDisplaysTheCorrespondingOrganization": "小程序会显示相应的组织类型文案",
  "shareTitle": "分享标题",
  "shareImage": "分享图片",
  "launchImage": "启动图",
  "shownFullScreenForAbout25": "进入小程序时全屏展示约 2.5 秒，支持 GIF 动图；未配置则直接进入首页",
  "themeColor": "主题颜色",
  "textVerification": "文本校验开关",
  "on": "打开",
  "off": "关闭",
  "miniProgram": "小程序设置",
  "miniProgramAppID": "小程序 AppID",
  "weChatMiniProgramAppID": "微信小程序 AppID",
  "miniProgramAppSecret": "小程序密钥",
  "enterTheWeChatMiniProgramAppSecretLeave": "填写微信小程序的 AppSecret；留空表示不修改已保存的密钥。",
  "weChatAccount": "公众号设置",
  "weChatAccountName": "公众号名称",
  "enterTheWeChatAccountNameUsedAs": "填写公众号名称，用于导入文章的发布人",
  "usedAsThePublisherNameWhenImporting": "用于公众号文章导入后的发布人展示。",
  "weChatAccountAppID": "公众号 AppID",
  "weChatOfficialAccountAppID": "微信公众号 AppID",
  "theAppIDAndSecretAreUsedFor": "AppID 和密钥用于公众号接口访问；粘贴文章链接导入仅需填写公众号名称。",
  "weChatAccountAppSecret": "公众号密钥",
  "leaveBlankToKeepTheSavedSecret": "留空表示不修改已保存的密钥",
  "agreements": "协议设置",
  "userAgreement": "用户协议",
  "enterTheUserAgreement": "用户协议内容",
  "privacyPolicy": "隐私政策",
  "enterThePrivacyPolicy": "隐私政策内容",
  "paymentSettings": "支付设置",
  "merchantID": "商户号",
  "weChatPayMerchantID": "微信支付商户号",
  "aPIV3Key": "API v3 密钥",
  "weChatPayPublicKeyID": "微信支付公钥 ID",
  "pUBKEYIDLeaveBlankWhenUsing": "PUB_KEY_ID_…；使用平台证书时可留空",
  "weChatPayPublicKeyCertificate": "微信支付公钥/平台证书",
  "uploadTheWeChatPayPublicKeyPEM": "上传微信支付提供的公钥 PEM 和对应公钥 ID；也支持上传微信支付平台证书（自动读取序列号）。",
  "paymentNotificationURL": "支付回调地址",
  "usedAutomaticallyWhenCreatingPaymentOrdersIt": "系统下单时自动使用此地址，须能通过公网 HTTPS 访问。商户号需要关联本小程序 AppID，并开通小程序支付。",
  "subscriptionMessages": "小程序消息通知",
  "membershipApproval": "入会申请成功通知",
  "subscriptionMessageTemplateID": "订阅消息模板 ID",
  "templateKeywordsSourceApprovalTimeReminder": "模板关键词：来自、通过时间、温馨提醒",
  "membershipExpiryReminder": "会员到期提醒",
  "templateKeywordsMemberNameMembershipTypeExpiry": "模板关键词：会员名称、会员类型、到期时间、备注",
  "registrationConfirmation": "活动报名成功通知",
  "templateKeywordsEventNameAmountPaidVenue": "模板关键词：活动名称、付款金额、活动地点、活动时间、联系电话",
  "sMSSettings": "短信配置服务",
  "sMSSignature": "短信签名",
  "alibabaCloudSMSSignatureName": "阿里云短信签名名称",
  "membershipApprovalSMS": "入会成功通知短信模板",
  "enterTheSMSTemplateCODE": "请输入短信模板 CODE",
  "templateDearWelcomeToXXXAssociationOur": "模板内容：尊敬的{token0},欢迎您加入XXX协会，XXX协会秘书处随时为您服务，请登录官方小程序XXX协会进行会员权益查看和使用，感谢您的支持",
  "upcomingFeeExpirySMS": "会费即将到期通知短信模板",
  "templateDearThankYouForSupportingXXX": "模板内容：尊敬的{token0}，您好!感谢您对XXX协会的支持与贡献，您的会费即将在{token1}到期，为了持续我们为您服务，请通过我们的官方小程序XXX协会续缴会费。如有任何疑问，欢迎随时联系协会秘书处。谢谢!",
  "membershipExpirySMS": "会员到期通知短信模板",
  "templateDearYourMembershipAtXXXAssociation": "模板内容：尊敬的{token0},您好，XXX协会您的{token1}会员已到期，为了您持续享受会员权益，建议您及时登录官方小程序XXX协会及时缴纳会费，感谢您对秘书处的配合!",
  "newMembershipApplicationSMS": "新会员入会申请通知短信模板",
  "templateANewMembershipApplicationWasReceived": "模板内容：有新的会员申请加入，姓名{token0},手机号{token1},请及时登录小程序或者管理后台进行审核!",
  "memberNotification": "通知会员",
  "templateDearYouHaveANewNotification": "模板内容：尊敬的{token0}，会员，您好！小程序有一条通知信息，请及时前往XXX协会个人中心查看!",
  "notUploaded": "尚未上传",
  "uploadAgain": "重新上传",
  "upload": "上传",
  "configuredLeaveBlankToKeep": "已配置（留空不修改）",
  "enterAValue": "请输入",
  "failedToLoadSettings": "加载配置失败",
  "miniProgramSettingsSaved": "小程序配置已保存",
  "noImageURLReturned": "未返回图片地址",
  "couldNotUploadImage": "图片上传失败",
  "certificateUploadedToLocalStorage": "证书已上传至本地存储",
  "couldNotUploadCertificate": "证书上传失败",
  "uploadedFile": "已上传：{name}",
  "localCertificate": "本地证书",
  "missingUploadObjectKey": "上传失败：未返回 object_key"
}
